import $ from 'jquery';
import { peopleAndExpertiseSliderConfig } from './sliders-config';

export function initPeopleSlider() {
  const peopleSliderSection = $('.section--people-slider');
  const btn = peopleSliderSection.find('.section__button');
  const href = btn.attr('href');

  btn.on('click', function () {
    $('html, body').animate({
      scrollTop: ($(href).offset().top - 120)
    }, 1000);
  });

  if($('.js-people-slider')) {
    const config = peopleAndExpertiseSliderConfig();
    
    $('.js-people-slider').slick(config);
  }
};
